module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.f98e4b13.webp";